export const HeaderLogo = ({ children }: { children: React.ReactNode }) => children;
HeaderLogo.displayName = "HeaderLogo";

export const HeaderProfile = ({ children }: { children: React.ReactNode }) => children;
HeaderProfile.displayName = "HeaderProfile";

export const HeaderMobileRight = ({ children }: { children: React.ReactNode }) => children;
HeaderMobileRight.displayName = "HeaderMobileRight";
